export const getFormattedDate = (date) => {
  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
};

const dateObject = new Date(date);

  return dateObject.toLocaleString('en-US', options).replace(',', '').replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$2 $1, $3')
}
